export const globalNudgeObjectPopupData = {
  saved_search: {
    htmlId: "saved-search-button",
    key: "saved_search",
    shouldPop: false,
    iconUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1683696233/intel/icons/nudge_savesearch_icon_krmu1k.svg",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1683696044/intel/icons/nudge_bg_jpxg8m.svg",
    applyButtonText: "Continue to Save Search",
    cancelButtonText: "Close",
    timer: 4000, // in mili seconds (minus 1 sec than requirement)
  },
  notification_center: {
    htmlId: "notification-bell",
    key: "notification_center",
    shouldPop: false,
    iconUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1685518703/intel/icons/nudge_savesearch_icon_xgv2m3.svg",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1683696044/intel/icons/nudge_bg_jpxg8m.svg",
    applyButtonText: "View Notification",
    cancelButtonText: "Close",
    timer: 10, // in mili seconds (minus 1 sec than requirement)
  },
  multi_country_nudge: {
    htmlId: "multi-country-nudge",
    key: "multi_country_nudge",
    shouldPop: false,
    iconUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1685518703/intel/icons/nudge_savesearch_icon_xgv2m3.svg",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1683696044/intel/icons/nudge_bg_jpxg8m.svg",
    applyButtonText: "View Notification",
    cancelButtonText: "Close",
    timer: 10, // in mili seconds (minus 1 sec than requirement)
  },
  renewal_banner: {
    htmlId: "renewal-banner",
    key: "renewal_banner",
    shouldPop: false,
    iconUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1685518703/intel/icons/nudge_savesearch_icon_xgv2m3.svg",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1683696044/intel/icons/nudge_bg_jpxg8m.svg",
    applyButtonText: "View Notification",
    cancelButtonText: "Close",
    timer: 10, // in mili seconds (minus 1 sec than requirement)
    planId: "",
  },
  second_level: {
    htmlId: "second-level-toggle",
    key: "second_level",
    shouldPop: false,
    iconUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1685518703/intel/icons/nudge_savesearch_icon_xgv2m3.svg",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1683696044/intel/icons/nudge_bg_jpxg8m.svg",
    applyButtonText: "Enable 2nd Level Hierarchy",
    cancelButtonText: "Close",
    timer: 2000, // in mili seconds (minus 1 sec than requirement)
    planId: "",
  },
  all_app: {
    htmlId: "all-app",
    key: "all_app",
    shouldPop: false,
    iconUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1698731915/intel/icons/apps_tdyv4p.svg",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1683696044/intel/icons/nudge_bg_jpxg8m.svg",
    applyButtonText: "Show All Apps",
    cancelButtonText: "Close",
    timer: 2000, // in mili seconds (minus 1 sec than requirement)
    planId: "",
  },
  intel_controls: {
    htmlId: "intel-controls",
    key: "all_app",
    shouldPop: false,
    iconUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1698731915/intel/icons/apps_tdyv4p.svg",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1683696044/intel/icons/nudge_bg_jpxg8m.svg",
    applyButtonText: "Show All Apps",
    cancelButtonText: "Close",
    timer: 2000, // in mili seconds (minus 1 sec than requirement)
    planId: "",
  },
  crm: {
    htmlId: "crm",
    key: "crm",
    shouldPop: false,
    iconUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1698731915/intel/icons/apps_tdyv4p.svg",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1683696044/intel/icons/nudge_bg_jpxg8m.svg",
    applyButtonText: "Get in Touch",
    cancelButtonText: "Not Interested",
    timer: 2000, // in mili seconds (minus 1 sec than requirement)
    planId: "",
  },
  glossary: {
    htmlId: "resource_center_header",
    key: "glossary",
    shouldPop: false,
    icon: "help",
    iconUrl: "",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1683696044/intel/icons/nudge_bg_jpxg8m.svg",
    applyButtonText: "",
    cancelButtonText: "Close",
    timer: 2000,
    planId: "",
  },
  new_credit_system: {
    htmlId: "new_credit_system",
    key: "new_credit_system",
    shouldPop: false,
    icon: "",
    iconUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1741088714/intel/icons/nudge_savesearch_icon_vdxzfp.svg",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1754487872/intel/misc/creditillustration_1_pvnhlw.svg",
    applyButtonText: "Learn More",
    cancelButtonText: "Okay",
    timer: 2000,
    planId: "",
  },
  hs_classifier: {
    htmlId: "hs_classifier",
    key: "hs_classifier",
    shouldPop: false,
    icon: "",
    iconUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1741088714/intel/icons/nudge_savesearch_icon_vdxzfp.svg",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1756380249/intel/misc/hsclassifer_oxsxkj.svg",
    applyButtonText: "Try Now",
    cancelButtonText: "Close",
    timer: 1000,
    planId: "",
  },
  due_diligence_reports: {
    htmlId: "due_diligence_reports",
    key: "due_diligence_reports",
    shouldPop: false,
    icon: "",
    iconUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1741088714/intel/icons/nudge_savesearch_icon_vdxzfp.svg",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1754487893/intel/misc/duediligencereport_3_ye8n2e.svg",
    applyButtonText: "",
    cancelButtonText: "Close",
    timer: 2000,
    planId: "",
  },
  compare_tariff: {
    htmlId: "compare_tariff",
    key: "compare_tariff",
    shouldPop: false,
    icon: "",
    iconUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1741088714/intel/icons/nudge_savesearch_icon_vdxzfp.svg",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1758793797/intel/Compare_tariff_nudge_image_fxddds.svg",
    applyButtonText: "Try Now",
    cancelButtonText: "Close",
    timer: 1000,
    planId: "",
  },
  company_search: {
    htmlId: "company_search",
    key: "company_search",
    shouldPop: false,
    icon: "",
    iconUrl: "",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1762166119/intel/misc/Company_search_nudge_image_1_hxt1yd.svg",
    applyButtonText: "Try Now",
    cancelButtonText: "Close",
    timer: 1000,
    planId: "",
  },
  intel_hub: {
    htmlId: "intel_hub",
    key: "intel_hub",
    shouldPop: false,
    icon: "",
    iconUrl: "",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1774504573/website/Tradescreen/intel_hub_nudge_image_qxau5v.svg",
    applyButtonText: "Try Now",
    cancelButtonText: "Close",
    timer: 1000,
    planId: "",
    closeEvent: "intel_hub_nudge_close",
    applyEvent: "intel_hub_nudge_try_now",
  },
  hermes_chat: {
    htmlId: "hermes_chat",
    key: "hermes_chat",
    shouldPop: false,
    icon: "",
    iconUrl: "",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1783604714/intel/misc/hermes_nudge_image_gvheel.webp",
    applyButtonText: "Try Now",
    cancelButtonText: "Close",
    timer: 1000,
    planId: "",
    closeEvent: "hermes_chat_nudge_close",
    applyEvent: "hermes_chat_nudge_try_now",
  },
  product_search: {
    htmlId: "product_search",
    key: "product_search",
    shouldPop: false,
    icon: "",
    iconUrl: "",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1778831256/intel/misc/product_search_nudge_hiw6es.webp",
    applyButtonText: "Try Now",
    cancelButtonText: "Close",
    timer: 1000,
    planId: "",
    closeEvent: "product_search_nudge_close",
    applyEvent: "product_search_nudge_try_now",
  },
  // Workspace nudge is shown once per module (Product Search, Company Search, Importer/Exporter "UI-UE").
  // All three share the same visual/content (rendered by the "workspace" family branch in nudgePopup.js)
  // and anchor to the same "add_to_workspace_nudge" button id, but use distinct feature keys so each is
  // tracked/dismissed independently via featureNudge / featureNudgeUpdate and the nudgeCache.
  workspace_product_search: {
    htmlId: "add_to_workspace_nudge",
    key: "workspace_product_search",
    shouldPop: false,
    icon: "",
    iconUrl: "",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1777889072/intel/misc/Workspace_empty_state_illustration_hbwdw6.webp",
    applyButtonText: "",
    cancelButtonText: "Close",
    position: "left",
    timer: 1000,
    planId: "",
    closeEvent: "workspace_product_search_nudge_close",
  },
  workspace_company_search: {
    htmlId: "add_to_workspace_nudge",
    key: "workspace_company_search",
    shouldPop: false,
    icon: "",
    iconUrl: "",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1777889072/intel/misc/Workspace_empty_state_illustration_hbwdw6.webp",
    applyButtonText: "",
    cancelButtonText: "Close",
    position: "left",
    timer: 1000,
    planId: "",
    closeEvent: "workspace_company_search_nudge_close",
  },
  workspace_ui_ue: {
    htmlId: "add_to_workspace_nudge",
    key: "workspace_ui_ue",
    shouldPop: false,
    icon: "",
    iconUrl: "",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1777889072/intel/misc/Workspace_empty_state_illustration_hbwdw6.webp",
    applyButtonText: "",
    cancelButtonText: "Close",
    position: "left",
    timer: 1000,
    planId: "",
    closeEvent: "workspace_ui_ue_nudge_close",
  },
};
export const nudgePopupDataCompanyProfile = {
  due_diligence_reports: {
    htmlId: "due_diligence_reports",
    key: "due_diligence_reports",
    shouldPop: false,
    icon: "",
    iconUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1741088714/intel/icons/nudge_savesearch_icon_vdxzfp.svg",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1754487893/intel/misc/duediligencereport_3_ye8n2e.svg",
    applyButtonText: "",
    cancelButtonText: "Close",
    timer: 2000,
    planId: "",
  },
};
